import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WebAppLogin from './WebAppLogin';
import WebAppJoin from './WebAppJoin';

const SignIn = () => {
  const [showJoinForms, setShowJoinForms] = useState(false);
  const navigate = useNavigate();

  const handleJoinClick = () => {
    navigate('/nonmembers'); // Web Join page
  };

  const handleLoginClick = () => {
    navigate('/member'); // Web Login page
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        width: '100%',
        backgroundColor: '#ffffff',
        overflow: 'hidden',
      }}
    >
      <div
        className="d-flex flex-row justify-content-center align-items-center w-100"
        style={{ maxWidth: '800px', margin: '0 auto', columnGap: '1.5rem' }}
      >
        {!showJoinForms ? (
          <>
            {/* Login Container */}
            <div style={{ flex: '0 0 50%' }}>
              <WebAppLogin onLoginClick={handleLoginClick} />
            </div>
            {/* Join Container */}
            <div style={{ flex: '0 0 50%' }}>
              <WebAppJoin onJoinClick={handleJoinClick} />
            </div>
          </>
        ) : (
          <div style={{ width: '100%' }}>
            <WebAppJoin showForms={showJoinForms} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SignIn;
